/* ag-cart-feedback v1 — reactive add-to-cart / cart-count feedback.
   Subscribes to the theme's existing MinimogEvents pub/sub only.
   Never calls cart endpoints, never touches forms, fetch, or submit handlers. */
(function () {
  'use strict';
  if (window.__agCartFeedback) return;
  window.__agCartFeedback = true;

  var ATC_SELECTOR = 'button[name="add"].add-to-cart';
  var COUNT_SELECTOR = '.cart-count,[class*="cart-count"],[data-cart-count]';
  var successTimers = new WeakMap();

  function markAdded() {
    document.querySelectorAll(ATC_SELECTOR).forEach(function (btn) {
      var rect = btn.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return; // hidden instances
      btn.classList.add('ag-atc-success');
      var prev = successTimers.get(btn);
      if (prev) clearTimeout(prev); // interruptible: rapid re-adds restart cleanly
      successTimers.set(btn, setTimeout(function () {
        btn.classList.remove('ag-atc-success');
        successTimers.delete(btn);
      }, 1600));
    });
  }

  function bumpCounts() {
    document.querySelectorAll(COUNT_SELECTOR).forEach(function (el) {
      el.classList.remove('ag-count-bump');
      void el.offsetWidth; // restart the animation
      el.classList.add('ag-count-bump');
      el.addEventListener('animationend', function handler() {
        el.classList.remove('ag-count-bump');
        el.removeEventListener('animationend', handler);
      });
    });
  }

  function wire(events) {
    try {
      events.subscribe('ON_ITEM_ADDED', function () {
        markAdded();
        bumpCounts();
      });
      events.subscribe('ON_CART_UPDATE', bumpCounts);
      events.subscribe('ON_FOX_CART_UPDATE', bumpCounts);
    } catch (e) { /* pub/sub shape changed — degrade to nothing */ }
  }

  // MinimogEvents may register after us; poll briefly, then give up silently.
  var tries = 0;
  (function waitForEvents() {
    if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
      wire(window.MinimogEvents);
      return;
    }
    if (++tries < 40) setTimeout(waitForEvents, 250); // up to ~10s
  })();
})();
